export const FRAME_MOVE = 'move'
export const FRAME_CAPTURE = 'capture'
export const FRAME_PROMOTE = 'promote'
export const FRAME_PICK_UP = 'pick-up'
export const FRAME_PUT_DOWN = 'put-down'
export const FRAME_FINISH = 'finish'

export class BoardAnimation {
  constructor() {
    this._keyframes = []
    this._frameIndex = 0
    this._completed = false
    this._pending = false
    this.promise = new Promise((resolve, reject) => {
      this._resolve = resolve
      this._reject = reject
    })
  }

  addMove(steps, callback) {
    if (this._keyframes.length === 0) {
      this._keyframes.push({
        type: FRAME_PICK_UP,
        index: steps[0],
        duration: 0,
      })
    }

    for (let i = 1; i < steps.length; i++) {
      this._keyframes.push({
        type: FRAME_MOVE,
        index: [steps[i - 1], steps[i]],
        duration: 75,
      })
    }

    this._keyframes.push({
      type: FRAME_PUT_DOWN,
      index: steps[steps.length - 1],
      duration: 25,
      callback,
    })
  }

  addCapture(index, callback) {
    this._keyframes.pop()

    this._keyframes.push({ type: FRAME_CAPTURE, index, duration: 0, callback })
  }

  addPromote(index, piece, callback) {
    this._keyframes.push({
      type: FRAME_PROMOTE,
      index,
      piece,
      duration: 0,
      callback,
    })
  }

  addFinish(callback) {
    this._keyframes.push({ type: FRAME_FINISH, duration: 0, callback })
  }

  async run(frameCallback) {
    if (this._pending) {
      return
    }

    if (this._completed) {
      this._reject()
      return
    }

    this._pending = true

    const callNextFrame = () => {
      const frame = this._keyframes[this._frameIndex]

      if (this._keyframes.length === 1) {
        frameCallback({
          index: this._frameIndex,
          class: frame.type === FRAME_MOVE ? 'in-out' : null,
          frame: frame,
        })
      } else if (this._frameIndex === this._keyframes.length - 1) {
        frameCallback({
          index: this._frameIndex,
          class: frame.type === FRAME_MOVE ? 'out' : null,
          frame: frame,
        })
      } else if (this._frameIndex > 0) {
        frameCallback({
          index: this._frameIndex,
          class: frame.type === FRAME_MOVE ? 'linear' : null, //linear?
          frame: frame,
        })
      } else {
        frameCallback({
          index: this._frameIndex,
          class: frame.type === FRAME_MOVE ? 'in' : null,
          frame: frame,
        })
      }

      this._frameIndex++

      if (this._frameIndex < this._keyframes.length) {
        setTimeout(() => {
          if (frame.callback) {
            frame.callback()
          }
          callNextFrame()
        }, frame.duration)
      } else {
        setTimeout(() => {
          if (frame.callback) {
            frame.callback()
          }
          this._completed = true
          this._pending = false
          this._resolve()
        }, frame.duration)
      }
    }

    callNextFrame()

    return this.promise
  }
}
